/**
 * Login Log Store
 * FSD: features/auth/stores
 *
 * 로그인 로그 ID 상태 관리
 */

import { create } from "zustand";
import { persist } from "zustand/middleware";
import { ZUSTAND_PERSIST_KEY } from "@/shared/lib/constants";

interface LogIdStore {
  logIdState: number | null;
  setLogIdState: (logId: number | null) => void;
}

export const useLogIdStore = create<LogIdStore>()(
  persist(
    (set) => ({
      logIdState: null,
      setLogIdState: (logId) => set({ logIdState: logId }),
    }),
    {
      name: `${ZUSTAND_PERSIST_KEY}-logid`,
    }
  )
);
